/**
 * MapTiler raster tile URL for Leaflet TileLayer (streets style).
 *
 * REACT_APP_MAPTILER_KEY is still shipped in the client JS bundle - it is not secret.
 * Using env keeps one place to rotate the key and avoids hardcoding the same literal in many components.
 */
export function getMapTilerStreetTileUrl() {
  const key = process.env.REACT_APP_MAPTILER_KEY || "";
  return `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${key}`;
}
